import { capitaliseFirstLetter } from '@akin-home/utils/strings';
import { format } from 'date-fns';
import { OpenWeatherV2HourData, OpenWeatherV2Response } from './types';

export const weather_functions = {
  getTemperature(data: OpenWeatherV2Response) {
    return data.current.temp;
  },
  getTemperatureText(data: OpenWeatherV2Response) {
    return `${Math.round(this.getTemperature(data))}°`;
  },
  getWeatherDescription(data: OpenWeatherV2Response) {
    return capitaliseFirstLetter(data.current.weather[0].description);
  },
  getIcon(data: OpenWeatherV2Response) {
    return data.current.weather[0].icon;
  },

  getHourTemperatureText(data: OpenWeatherV2HourData) {
    return `${Math.round(data.temp)}°`;
  },

  getHourTimeText(data: OpenWeatherV2Response, hour: OpenWeatherV2HourData) {
    // const timestamp_in_seconds = hour.dt + data.timezone_offset;

    return format(new Date(hour.dt * 1000), 'h a');
  },

  getHourIcon(hour: OpenWeatherV2HourData) {
    return hour.weather[0].icon;
  },
};
